// extracted by mini-css-extract-plugin
module.exports = {"sec_testimonials":"Testimonials_sec_testimonials__Aqgu5","title":"Testimonials_title__2WwOY","cont_testimonials":"Testimonials_cont_testimonials__1SBac"};